export const FR = {
  required: 'Ce champ est requis',
  emptyFields: 'Champs manquants',
  submit: 'Valider',
  file: 'Choisissez un fichier',
  fileError: 'Taille du fichier trop large, veuillez en choisir un autre.',
  tooBig: 'Fichier trop volumineux.',
  onPressMessage: 'Pressez la touche Entrer pour valider chaque mot.',
  uploadFile: 'Téléchargez',
  error: 'Erreur',
  success: 'Succès',
  nothingUpdated: 'Rien n\'a été actualisé dans le formulaire.',
}

export const EN = {
  required: 'Field required',
  emptyFields: 'Empty fields',
  submit: 'Submit',
  file: 'Choose File',
  fileError: 'Size of file too large, please choose another one.',
  tooBig: 'File too big.',
  onPressMessage: 'Press Enter to store each word',
  uploadFile: 'Upload File',
  error: 'Error',
  success: 'Success',
  nothingUpdated: 'Nothing updated into form',
}

export default {
  fr: FR,
  us: EN,
}
